// frontend_app/src/lib/cx.js

/** Join class names, skipping falsy values. */
export const cx = (...classes) => classes.filter(Boolean).join(' ');
